import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { find, get, head, includes, isEmpty, isNil, orderBy, trimStart } from 'lodash-es';
import { Observable, forkJoin, from, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { SubscriptionBusinessService } from 'src/app/account/services/subscription-business.service';
import { SubscriptionDataService } from 'src/app/account/services/subscription-data.service';
import { AppService } from 'src/app/app.service';
import { NS_SubscriptionService, newPricingRoute } from 'src/app/shared/namespaces';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionsGuard  {

  constructor(private router: Router,
    private subscriptionBusinessService: SubscriptionBusinessService,  private appService: AppService, private subscriptionDataService: SubscriptionDataService, ) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url = 'u/account/billing-details';
    const tree: UrlTree = this.router.parseUrl(url);
    // const hasSubscriptionFeaturePersmissionOrFallback:any = from(this.appService.getUser()).pipe(
    //   map(user => {
    //     return this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(user?.company?.companyId).subscribe(
    //       (response:any) => {
    //         let newCompanySubscriptions = get(response, 'data.content');
    //         this.subscriptionBusinessService.companySubscriptions = newCompanySubscriptions;
    //         let userRoleFromAPI = get(user, 'role');
    //         let hasPermission = false;
    //         hasPermission = this.subscriptionBusinessService.checkSubscriptionFeaturePersmission(userRoleFromAPI );
    //         if(hasPermission){
    //           return true;
    //         } else{
    //           return tree;
    //         }
    //     })
    //   }),
    //   catchError((error: any) => {
    //     return of(tree);
    //   })
    // )
    // return hasSubscriptionFeaturePersmissionOrFallback;

    return new Observable<any>((observer)=>{
      //observer.next(true);
      from(this.appService.getUser()).pipe(take(1), catchError((error: any) => { return of(tree) })  ).subscribe((user:any)=>{
        this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(user?.company?.companyId).pipe( take(1), catchError((error: any) => { return of(tree) }) ).subscribe((response:any)=>{
          let newCompanySubscriptions = response;
          this.subscriptionBusinessService.companySubscriptions = newCompanySubscriptions;
          let userRoleFromAPI = get(user, 'role');
          let hasPermission = false;
          let managedBySarasOnly = get(state, 'url')?.includes(NS_SubscriptionService.subscriptionTabsEnum.paymentdetails) ?  !get(get(find(newCompanySubscriptions, {status : NS_SubscriptionService.ACTIVE}), "subscriptionPlan"), "managedBySarasOnly") : true
          hasPermission = this.subscriptionBusinessService.checkSubscriptionFeaturePersmission(userRoleFromAPI ) && managedBySarasOnly;          
          if(hasPermission){
            observer.next(true);
          } else{
            observer.next(tree);
          }
        })
      })
    });
     
  }
  
}


@Injectable({
  providedIn: 'root'
})
export class OldSubscriptionsGuard  {

  constructor(private router: Router,
    private subscriptionBusinessService: SubscriptionBusinessService,  private appService: AppService
    , private subscriptionDataService: SubscriptionDataService) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url = 'u/account/subscription';
    const tree: UrlTree = this.router.parseUrl(url);
    // const hasOldSubscriptionFeaturePersmissionOrFallback:any = from(this.appService.getUser()).pipe(
    //   map(user => {
    //     return this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(user?.company?.companyId).subscribe(
    //       (response:any) => {
    //         let newCompanySubscriptions = get(response, 'data.content');
    //         this.subscriptionBusinessService.companySubscriptions = newCompanySubscriptions;
    //         let userRoleFromAPI = get(user, 'role');
    //         let hasPermission = this.subscriptionBusinessService.checkOldSubscriptionFeaturePersmission(userRoleFromAPI);
    //         if(hasPermission){
    //           return true;
    //         } else{
    //           return tree;
    //         }
    //     })
    //   }),
    //   catchError((error: any) => {
    //     return of(tree);
    //   })
    // )
    // return hasOldSubscriptionFeaturePersmissionOrFallback;
    return new Observable<any>((observer)=>{
      // observer.next(tree);
      
      
      from(this.appService.getUser()).pipe(take(1), catchError((error: any) => { return of(tree) })  ).subscribe((user:any)=>{
        this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(user?.company?.companyId).pipe( take(1), catchError((error: any) => { return of(tree) }) ).subscribe((response:any)=>{
          let newCompanySubscriptions = response;
          this.subscriptionBusinessService.companySubscriptions = newCompanySubscriptions;
          let userRoleFromAPI = get(user, 'role');
          let hasPermission = this.subscriptionBusinessService.checkOldSubscriptionFeaturePersmission(userRoleFromAPI);
          if(hasPermission){
            observer.next(true);
          } else{
            observer.next(tree);
          }
        })
      })
    })
  }
  
}


@Injectable({
  providedIn: 'root'
})
export class OldPricingGuard  {

  constructor(private router: Router,
    private subscriptionBusinessService: SubscriptionBusinessService,  private appService: AppService
    , private subscriptionDataService: SubscriptionDataService) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url = trimStart(newPricingRoute,'/'); // 'u/pricing';
    const tree: UrlTree = this.router.parseUrl(url);
    // const hasOldSubscriptionFeaturePersmissionOrFallback:any = from(this.appService.getUser()).pipe(
    //   map(user => {
    //     return this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(user?.company?.companyId).subscribe(
    //       (response:any) => {
    //         let newCompanySubscriptions = get(response, 'data.content');
    //         this.subscriptionBusinessService.companySubscriptions = newCompanySubscriptions;
    //         let userRoleFromAPI = get(user, 'role');
    //         let hasPermission = this.subscriptionBusinessService.checkOldSubscriptionFeaturePersmission(userRoleFromAPI);
    //         if(hasPermission){
    //           return true;
    //         } else{
    //           return tree;
    //         }
    //     });
    //   }),
    //   catchError((error: any) => {
    //     return of(tree);
    //   })
    // )
    // return hasOldSubscriptionFeaturePersmissionOrFallback;
    return new Observable<any>((observer)=>{

      observer.next(tree);

      // from(this.appService.getUser()).pipe(take(1), catchError((error: any) => { return of(tree) })  ).subscribe((user:any)=>{
      //   this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(user?.company?.companyId).pipe( take(1), catchError((error: any) => { return of(tree) }) ).subscribe((response:any)=>{
      //     let newCompanySubscriptions = get(response, 'data.content');
      //     this.subscriptionBusinessService.companySubscriptions = newCompanySubscriptions;
      //     let userRoleFromAPI = get(user, 'role');
      //     let hasPermission = this.subscriptionBusinessService.checkOldSubscriptionFeaturePersmission(userRoleFromAPI);
      //     if(hasPermission){
      //       observer.next(true);
      //     } else{
      //       observer.next(tree);
      //     }
      //   })
      // })
    })
  }
  
}

@Injectable({
  providedIn: 'root'
})
export class NewPricingGuard  {

  constructor(private router: Router,
    private subscriptionBusinessService: SubscriptionBusinessService,  private appService: AppService, private subscriptionDataService: SubscriptionDataService, ) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url = 'u/subscription-pricing';
    const tree: UrlTree = this.router.parseUrl(url);
    // const hasSubscriptionFeaturePersmissionOrFallback:any = from(this.appService.getUser()).pipe(
    //   map(user => {
    //     return this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(user?.company?.companyId).subscribe(
    //       (response:any) => {
    //         let newCompanySubscriptions = get(response, 'data.content');
    //         this.subscriptionBusinessService.companySubscriptions = newCompanySubscriptions;
    //         let userRoleFromAPI = get(user, 'role');
    //         let hasPermission = false;
    //         hasPermission = this.subscriptionBusinessService.checkSubscriptionFeaturePersmission(userRoleFromAPI );
    //         if(hasPermission){
    //           return true;
    //         } else{
    //           return tree;
    //         }
    //       });
    //     }),
    //     catchError((error: any) => {
    //       return of(tree);
    //     })
    // )
    // return hasSubscriptionFeaturePersmissionOrFallback;

    return new Observable<any>((observer)=>{
      observer.next(true);
      // from(this.appService.getUser()).pipe(take(1), catchError((error: any) => { return of(tree) })  ).subscribe((user:any)=>{
      //   this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(user?.company?.companyId).pipe( take(1), catchError((error: any) => { return of(tree) }) ).subscribe((response:any)=>{
      //     let newCompanySubscriptions = get(response, 'data.content');
      //     this.subscriptionBusinessService.companySubscriptions = newCompanySubscriptions;
      //     let userRoleFromAPI = get(user, 'role');
      //     let hasPermission = false;
      //     hasPermission = this.subscriptionBusinessService.checkSubscriptionFeaturePersmission(userRoleFromAPI );
      //     if(hasPermission){
      //       observer.next(true);;
      //     } else{
      //       observer.next(tree);
      //     }
      //   })
      // })
    })
     
  }
  
}